// extracted by mini-css-extract-plugin
export default {"heading":"Header_heading__iiSGF","light":"Header_light__Uircu","subHeader":"Header_subHeader__PuVa5"};